import { defineAction } from '~/prix'
import { z } from 'zod'
import creditBracketUpdateAction from './creditBracketUpdate.action.json' with { type: 'json' }
import { creditBracketUpdateInputObject } from '../creditBracketObject'

const creditBracketUpdateDefinition = defineAction({
  ...creditBracketUpdateAction,

  input: creditBracketUpdateInputObject,
  output: z.object({}),
})

export default creditBracketUpdateDefinition

